import { render } from "./RightClickMenu.vue?vue&type=template&id=29e5c4b2&scoped=true"
import script from "./RightClickMenu.vue?vue&type=script&lang=js"
export * from "./RightClickMenu.vue?vue&type=script&lang=js"

import "./RightClickMenu.vue?vue&type=style&index=0&id=29e5c4b2&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e5c4b2"]])

export default __exports__